<template lang="pug">
  div.sidebar
    slot
</template>

<script>
export default {
  name: "sidebar",
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 68px;
  bottom: 0;
  width: 220px;
  overflow: hidden;
  background-color: #ffffff;
  z-index: 1070;
  overflow-x: hidden;
  overflow-y: auto;
}

.sidebar-device {
  position: fixed;
  top: 68px;
  bottom: 0;
  width: 220px;
  overflow: hidden;
  background-color: #ffffff;
  z-index: 1071;
  overflow-x: hidden;
  overflow-y: auto;
}

.sidebar::-webkit-scrollbar {
  width: 4px;
  height: 8px;
  margin-right: 1px;
}
.sidebar::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
